import { useState, useEffect } from "react";
import "./SearchContent.scss";
import { newsCountProps } from "./newsContent.types";
import moment from "moment";
import Sort from "../Common/Sort/Sort";
import useWindowDimemsions from "../../hooks/useWindowDimesnions";

const SearchContent = <T extends {}>({
  setSingleNews,
  allNews,
  filterType,
}: newsCountProps<T>) => {

  const [newsList, setNewsList] = useState<any[] | []>([]);
  const [newsList2, setNewsList2] = useState<any[] | []>([]);

  useEffect(() => { setNewsList2(allNews); }, [allNews]);

  const sortSentiment = [
    "Sort By: Date - Newest to Oldest",
    "Sort By: Date - Oldest to Newest",
    "Sort By: Sentiment - Positive to Negative",
    "Sort By: Sentiment - Negative to Positive",
  ];

  useEffect(() => { setNewsList(allNews); }, [allNews]);

  useEffect(() => {
    if (filterType === "news") {
      setNewsList([...newsList2.filter((w: any) => w.key === "news")]);
    } else if (filterType === "tweets") {
      setNewsList([...newsList2.filter((w: any) => w.key === "tweets")]);
    } else if (filterType === "all") {
      setNewsList([...newsList2]);
    }
  }, [filterType]);

  const sortByScore = (event: string) => {
    if (event === "Sort By: Date - Newest to Oldest") {
      setNewsList([...newsList2.sort((a: any, b: any) =>
        new Date(b.News_date || b.Tweets_date).getTime() - new Date(a.News_date || a.Tweets_date).getTime()
      )]);
    } else if (event === "Sort By: Date - Oldest to Newest") {
      setNewsList([...newsList2.sort((a: any, b: any) =>
        new Date(a.News_date || a.Tweets_date).getTime() - new Date(b.News_date || b.Tweets_date).getTime()
      )]);
    } else if (event === "Sort By: Sentiment - Positive to Negative") {
      const pos = newsList2.filter((n: any) => (n.News_Sentiment || n.Tweets_Sentiment) === "positive");
      const neu = newsList2.filter((n: any) => (n.News_Sentiment || n.Tweets_Sentiment) === "neutral");
      const neg = newsList2.filter((n: any) => (n.News_Sentiment || n.Tweets_Sentiment) === "negative");
      setNewsList([...pos, ...neu, ...neg]);
    } else if (event === "Sort By: Sentiment - Negative to Positive") {
      const pos = newsList2.filter((n: any) => (n.News_Sentiment || n.Tweets_Sentiment) === "positive");
      const neu = newsList2.filter((n: any) => (n.News_Sentiment || n.Tweets_Sentiment) === "neutral");
      const neg = newsList2.filter((n: any) => (n.News_Sentiment || n.Tweets_Sentiment) === "negative");
      setNewsList([...neg, ...neu, ...pos]);
    }
  };

  const sentimentColor: Record<string, string> = {
    positive: "#16a34a",
    negative: "#dc2626",
    neutral:  "#d97706",
  };
  const sentimentBg: Record<string, string> = {
    positive: "#f0fdf4",
    negative: "#fff1f2",
    neutral:  "#fffbeb",
  };
  const sentimentBorder: Record<string, string> = {
    positive: "#bbf7d0",
    negative: "#fecdd3",
    neutral:  "#fde68a",
  };

  const { width }: any = useWindowDimemsions();
  const xsWidth = 576;
  const heightStyle =
    width && width < xsWidth && newsList?.length === 0
      ? { minHeight: "100px", maxHeight: "100px" }
      : width && width < xsWidth && newsList?.length > 0
      ? { maxHeight: "75vh" }
      : { minHeight: "75vh", maxHeight: "75vh" };

  return (
    <div className={`sc-panel col-md-3 mb-2 ${width && width > 768 ? "" : "mb-4"}`}>
      <div className="sc-inner" style={heightStyle}>

        {/* Header */}
        <div className="sc-header">
          <div className="sc-header-left">
            <span className="sc-title">Contents</span>
            {newsList.length > 0 && (
              <span className="sc-count">{newsList.length}</span>
            )}
          </div>
          <Sort sortSentiment={sortSentiment} sortByScore={sortByScore} title="Sort By" />
        </div>

        {/* List */}
        <div className="sc-list">
          {(newsList as any[]).map((news: any, index: number) => {
            const sentiment = news.key === "news" ? news.News_Sentiment : news.Tweets_Sentiment;
            const date      = news.key === "news" ? news.News_date      : news.Tweets_date;
            const source    = news.key === "news" ? news.News_Source     : "Tweet";
            const title     = news.key === "news" ? news.News_Title      : news.Actual_Tweets;
            const sColor    = sentimentColor[sentiment?.toLowerCase()] || sentimentColor.neutral;
            const sBg       = sentimentBg[sentiment?.toLowerCase()]    || sentimentBg.neutral;
            const sBorder   = sentimentBorder[sentiment?.toLowerCase()]|| sentimentBorder.neutral;

            return (
              <div
                key={index}
                className={`sc-card ${news.active ? "sc-card--active" : ""}`}
                style={{ borderLeftColor: sColor }}
                onClick={() => {
                  setSingleNews(news);
                  newsList.forEach((el) => (el.active = false));
                  newsList[index].active = true;
                  setNewsList([...newsList]);
                }}
              >
                {/* Top: source + sentiment */}
                <div className="sc-card-top">
                  {source && <span className="sc-source-pill">{source}</span>}
                  <span
                    className="sc-sentiment-badge"
                    style={{ color: sColor, background: sBg, border: `1px solid ${sBorder}` }}
                  >
                    {sentiment || "Neutral"}
                  </span>
                </div>

                {/* Title */}
                <p
                  className="sc-card-title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />

                {/* Date */}
                <span className="sc-card-date">
                  &#128197;&nbsp;{date ? moment(date).format("DD MMM YYYY, HH:mm") : "—"}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SearchContent;
